<template>
  <div class="book-mobile" :style="{ height: conHeight + 'px', backgroundColor: bgColor }">
    <div class="top-bar" :style="{ top: activePanel === 'menu' ? '0px' : '-160px' }">
      <div class="book-title">{{ book.title }}</div>
      <div class="btn-group" style="width: 45%">
        <div class="btn collection" :class="{ active: isCollect }" @click="toggleCollect"></div>
        <div class="btn note" @click="noteDrawer = true"></div>
        <div class="btn mark" :class="{ active: markNums.includes(curPage) }" @click="toggleMark"></div>
        <el-popover placement="bottom" width="100" trigger="click">
          <el-radio-group v-model="bgColor" @input="changeBg">
            <el-radio :label="mode.value" v-for="mode in predefineColors" :key="mode.text">{{ mode.text }}</el-radio>
          </el-radio-group>
          <div slot="reference" class="btn bgs"></div>
        </el-popover>
      </div>
    </div>
    <turn-book ref="turnBook" @click="toggleMenu" :pages="pages" :curPage="curPage" :isText="isText" />
    <div class="water-mark" :style="{ height: conHeight + 'px', backgroundImage: `url(${waterMark})`}"></div>
    <div class="turn-icon left" :style="{top: conHeight * 0.5 + 'px'}" @click="changePage('previous')"></div>
    <div class="turn-icon right" :style="{top: conHeight * 0.5 + 'px'}" @click="changePage('next')"></div>
    <div class="page-text" :style="{ bottom: bottom + 12 + 'px' }">{{ curPage + '/' + total }}</div>
    <div class="bottom-bar" :style="{ bottom: activePanel === 'menu' ? bottom + 'px' : bottom - 244 + 'px' }">
      <div class="flex-box">
        <div class="text-big" @click="changePage('previous')">上一页</div>
        <div class="progress"><el-slider :min="1" :max="total" v-model.lazy="curPageB" @change="syncPage" :show-tooltip="false"></el-slider></div>
        <div class="text-big" @click="changePage('next')">下一页</div>
      </div>
      <div class="btn-group" style="margin-top: 24px">
        <div class="bottom-btn">
            <div class="btn-big catalog" @click.stop="drawer = true"></div>
            <div>目录</div>
        </div>
        <div style="font-size: 48px;">{{ curPageB + '/' + total }}</div>
        <div class="bottom-btn">
            <div class="btn-big" :class="[isText ? 'switch-text' : 'switch-pic']" @click.stop="isText = !isText"></div>
            <div>图文切换</div>
        </div>
      </div>
    </div>
    <van-popup v-model="drawer" position="left" get-container="body">
      <div class="book-mobile-fill-menu" :style="{ height: height + 'px' }">
        <tabs @close="drawer = false"></tabs>
      </div>
    </van-popup>
    <van-popup v-model="noteDrawer" position="right" get-container="body">
      <div class="book-mobile-fill-menu" :style="{ height: height + 'px' }">
        <div class="part-title" slot="title" style="border-bottom: 2px solid #7c1823; padding-bottom: 8px;.font-size-medium;"><span class="inline-title">笔记</span></div>
        <el-input type="textarea" style="width: 280px;" :rows="12" placeholder="请输入内容" v-model="noteText"> </el-input>
        <div style="display: flex; margin-top: 16px;">
        <div class="draw-ct-btn" @click="noteDrawer = false">取消</div>
        <div class="draw-ct-btn" @click="saveNote">保存笔记</div>
      </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Tabs from './tabs'
import turnBook from './turn-book'
import Custom from '@/api/custom'
import { getSearchParams } from '@/utils'
import api from '@/api'
import EventUtils from './EventUtils'
let apiCollect = new Custom('bookCollections')
let apiNote = new Custom('bookNotes')
let apiMark = new Custom('bookMarks')
let apiWaterMark = new Custom('watermark')
export default {
  data () {
    return {
      conHeight: (window.innerHeight * 1080) / window.innerWidth,
      bottom: window.innerHeight - (window.innerHeight * 1080) / window.innerWidth,
      height: window.innerHeight,
      isCollect: false,
      collectionRecord: {},
      drawer: false,
      noteDrawer: false,
      noteText: '',
      curPageB: 1,
      curPage: 1,
      total: 100,
      pages: [],
      bgColor: '#f5f2eb',
      predefineColors: [
        { text: '默认', value: '#f5f2eb' },
        { text: '护眼绿', value: '#C7EDCC' },
        { text: '复古纸张', value: '#FFF2E2' }
      ],
      activePanel: '',
      activeName: 'catalog',
      waterMark: '',
      sourceId: '',
      isText: false,
      book: {}
    }
  },
  computed: {
    ...mapGetters(['marks']),
    localMarks () {
      return this.marks.filter(item => item.sourceId === this.sourceId)
    },
    markNums () {
      return this.localMarks.map(ele => Number(ele.pageNumber))
    }
  },
  components: {
    Tabs, turnBook
  },
  methods: {
    syncPage (val) {
        this.$nextTick(() => {
            this.curPage = val
        })
    },
    async getBook () {
      let res = await api.bookSearch({
        pageIndex: 1,
        pageSize: 1,
        advacedFilters: JSON.stringify({
          category: 'bookMetaData',
          sourceId: this.sourceId
        })
      })
      this.book = res[0]
      // await this.getStatistics()
    },
    getCollectionData () {
      apiCollect
        .getRecords({
          pageIndex: 1,
          pageSize: 999
        })
        .then(res => {
          let tar = res.rows.find(row => row.sourceId === this.sourceId)
          if (tar) {
            this.isCollect = true
            this.collectionRecord = tar
          }
        })
    },
    changePage (key) {
      switch (key) {
        case 'next':
          if (this.curPage >= this.total) return
          this.curPage += 1
          this.curPageB += 1
          break
        case 'previous':
          if (this.curPage < 2) return
          this.curPage -= 1
          this.curPageB -= 1
          break
      }
    },
    toggleCollect () {
      if (this.isCollect) {
        apiCollect
          .deleteRecord({
            id: this.collectionRecord.id
          })
          .then(() => {
            this.$message.success('取消收藏!')
            this.isCollect = false
          })
      } else {
        apiCollect
          .addRecord({
            sourceId: this.sourceId,
            sourceName: this.book.title
          })
          .then(() => {
            this.$message.success('收藏成功!')
            this.isCollect = true
          })
      }
    },
    saveNote () {
      apiNote
        .addRecord({
          sourceId: this.sourceId,
          sourceName: this.book.title,
          pageNumber: this.curPage,
          content: this.noteText
        })
        .then(() => {
          this.noteDrawer = false
          this.$message.success('笔记添加成功!')
          this.$store.dispatch('getNotes')
        })
    },
    getMarks () {
      this.$store.dispatch('getMarks')
    },
    toggleMark () {
      if (this.markNums.includes(this.curPage)) {
        let tar = this.localMarks.find(item => Number(item.pageNumber) === this.curPage)
        apiMark
          .deleteRecord({
            id: tar.id
          })
          .then(() => {
            this.getMarks()
            this.$message.success('移除标签!')
          })
      } else {
        apiMark
          .addRecord({
            sourceId: this.sourceId,
            sourceName: this.book.title,
            pageNumber: this.curPage
          })
          .then(() => {
            this.getMarks()
            this.$message.success('添加标签!')
          })
      }
    },
    changeBg (val) {
      this.bgColor = val
      localStorage.setItem('readerBg', val)
    },
    toggleMenu () {
      if (this.activePanel !== '') {
        this.activePanel = ''
      } else {
        this.activePanel = 'menu'
        this.curPageB = this.curPage
      }
    },
    initPage () {
      let page = getSearchParams(window.location.href).page
      if (page) {
        this.setPage(Number(page))
      }
    }
  },
  mounted () {
    if (localStorage.getItem('readerBg')) {
      this.bgColor = localStorage.getItem('readerBg')
    } else {
      localStorage.setItem('readerBg', this.bgColor)
    }
    apiWaterMark.getRecords({
      pageIndex: 1,
      pageSize: 1
    }).then(res => {
      this.waterMark = res.rows[0].imageBase64Str
    })
    let queryObj = getSearchParams(window.location.href)
    this.sourceId = queryObj.sourceId
    this.$store.dispatch('getConfidentialSourceIds').then(ids => {
      if (ids.includes(this.sourceId)) this.$router.push('/401')
    })
    api.getPagesBySourceId(this.sourceId).then(pageNum => {
      let pages = []
      for (let i = 1; i <= pageNum; i++) {
        pages.push({
          url: `/${this.sourceId.split('_')[0]}/${this.sourceId}/TIFF/` + String(i).padStart(4, '0') + '.jpg'
        })
      }
      this.pages = pages
      this.total = this.pages.length
      if (Number(queryObj.page) && Number(queryObj.page) !== 1) {
        this.curPage = Number(queryObj.page)
      } else {
         this.$refs.turnBook.getPage(1)
      }
    })
    this.getCollectionData()
    this.getMarks()
    this.getBook()
    this.$bus.$on('setPage', page => {
      this.curPageB = Number(page)
      this.curPage = Number(page)
    })
    function right () {
        // this.changePage('previous')
    }
    function left () {
        // this.changePage('next')
    }
    EventUtils.listenTouchDirection(document.querySelector('.book-mobile'), false, () => {}, right.bind(this), () => {}, left.bind(this))
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.book-mobile {
  width: 1080px;
  font-family: FangZhengKaiTi-GBK;
  .top-bar {
    width: 1080px;
    height: 160px;
    position: absolute;
    transition: top 0.5s;
    background-color: white;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .book-title {
      color: #7c1823;
      font-size: 48px;
      width: 40%;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    z-index: 2;
  }
  .btn-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .btn {
      width: 56px;
      height: 56px;
      background-size: 100% 100%;
    }
    .btn-big {
      width: 67px;
      height: 67px;
      background-size: 100% 100%;
    }
    .bottom-btn {
        font-size: 28px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
  }
  .turn-icon {
    width: 96px;
    height: 96px;
    background-size: 100% 100%;
    position: absolute;
    background-image: url("~@/assets/images/turn-icon.png");
    opacity: 0.5;
    z-index: 100;
    &.left {
        left: 25px;
        transform: rotateY(180deg);
    }
    &.right {
        left: 960px;
    }
  }
  .water-mark {
        width: 1080px;
        position: fixed;
        pointer-events: none;
        z-index: 1;
        padding: 0 24px;
        top: 0;
        background-size: auto 100%;
    }
  .page-text {
    position: absolute;
    left: 28px;
    font-size: 32px;
    color: #414441;
  }
  .bottom-bar {
    width: 1080px;
    height: 244px;
    background-color: #7c1823;
    position: absolute;
    // bottom: -1406px;
    transition: bottom 0.5s;
    padding: 23px 48px;
    color: white;
    z-index: 2;
    .flex-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .text-big {
      font-size: 48px;
    }
    .progress {
      width: 65%;
      // /deep/ .el-slider {
      //     transform: scaleY(3);
      // }
      // /deep/ .el-slider__button-wrapper {
      //     transform: scaleX(3);
      // }
      /deep/ .el-slider__runway {
        height: 18px;
      }
      /deep/ .el-slider__bar {
        height: 18px;
        // background-color:#f5f2eb;
      }
      /deep/ .el-slider__button-wrapper {
        height: 48px;
        width: 48px;
        top: -14px;
      }
      /deep/ .el-slider__button {
        width: 36px;
        height: 36px;
      }
    }
  }
}
</style>
<style lang="less">
@import "~@/styles/variables.less";
.book-mobile-fill-menu {
  width: 300px;
  padding: 35px 16px;
  .draw-ct-btn {
  width: 80px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "FangZhengKaiTi-GBK";
  .font-size-small;
  color: #7c1823;
  border: 2px solid #7c1823;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 24px;
}
}
</style>
